import { render } from "./SkeletonHorizontalCard.vue?vue&type=template&id=2aff75db"
import script from "./SkeletonHorizontalCard.vue?vue&type=script&lang=js"
export * from "./SkeletonHorizontalCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__